import { TFunction } from "i18next";
import { mixed, object, string } from "yup";

export const newFolderSchema = (t: TFunction) =>
  object({
    title: string()
      .required(t("folder.titleRequired"))
      .max(255, t("folder.titleLong")),
    url: string()
      .required(t("folder.urlRequired"))
      .max(255, t("folder.urlLong"))
      .matches(/^[A-Za-z0-9-_]+$/, t("page.urlCheck")),
    parentFolder: mixed().nullable(),
    parentDomain: mixed().nullable(),
  });
